<template>
    <b-row>
        <b-col cols="12" class="mb-2 mt-5">
            <label class="mb-2 h5 text-uppercase">
                Documentación del deportista
            </label>
            <DocumentosSubidosComponent :fotos="base.fotos_dni" :options="dropzoneOptionsDocumentacion" :text="text_dnis" @documentosSubidos="vdropzone_success_handler"></DocumentosSubidosComponent>
        </b-col>
        <b-col cols="12">
            <DocumentosSubidosComponent :fotos="base.foto_url" :options="dropzoneOptionsFotoPerfil" :text="text_foto_perfil" @documentosSubidos="vdropzone_success_handler_foto_perfil"></DocumentosSubidosComponent>
        </b-col>
        <b-col cols="12" class="text-right mt-4">
            <Button @click="volver()" name="button" class="mr-2" :disabled="!paso_activo">ATRÁS</Button>
            <Button id="terminar-paso-5" @click="continuar()" name="button" :disabled="!paso_activo">CONTINUAR</Button>
        </b-col>
    </b-row>
</template>

<script>
import DocumentosSubidosComponent from './DocumentosSubidosComponent.vue';

export default {
    props: ['base', 'paso_activo'],
    data() {
        return {
            dropzoneOptionsDocumentacion: {
                url: null,
                thumbnailWidth: 150,
                maxFilesize: 5,
                dictDefaultMessage: "Arrastra aquí tus archivos",
            },
            dropzoneOptionsFotoPerfil: {
                url: null,
                thumbnailWidth: 150,
                maxFilesize: 5,
                dictDefaultMessage: "Arrastra aquí tu foto de perfil",
            },
            text_dnis: `
                Si es de nueva inscripción, la información que deben adjuntar los padres son:
                <ul>
                    <li><b>DNI/NIE/Pasaporte (Ambas caras) Jugador</b></li>
                    <li>
                        <b>DNI/NIE/Pasaporte (Ambas caras) de los
                            responsables</b>
                    </li>
                </ul>
            `,
            text_foto_perfil: 'Foto del deportista para el perfil:',
            documentos_id: []
        }
    },
    methods: {
        volver() {
            this.$emit('volver');
        },
        continuar() {
            this.guardarDatosComprador();
            this.$emit('terminado');
        },
        guardarDatosComprador() {
            let params = {
                base: this.base,
                filters: {
                    tid: this.configuracion.hash_teatro
                }
            }

            this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-datos-deportista'), params).then(res => {});
        },
        vdropzone_success_handler(response) {
            this.documentos_id.push(response.documento_id);
            this.base['documentos_id'] = this.documentos_id;
        },
        vdropzone_success_handler_foto_perfil(response) {
            this.base.foto_url = response.url;
        },
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    created() {
        this.dropzoneOptionsDocumentacion["url"] = this.config.API_BASE + "/f/upload/documento" + "?tipo=bases&id=" + this.base["dni"];
        this.dropzoneOptionsFotoPerfil["url"] = this.config.API_BASE + "/f/guardar-foto-deportista";
    },
    components: {
        DocumentosSubidosComponent
    }
}
</script>t